import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    // Carry the path we turned away so LoginPage can land the user on it instead
    // of the default page (sc-6158). This wraps every route in the app, so the
    // deep link in a Slack notification clicked on a cold session — the common
    // case, since those get read hours later — survives the login round trip.
    // LoginPage re-validates `from` before using it; see utils/redirect.
    const from = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to="/login" replace state={{ from }} />;
  }

  return <>{children}</>;
};

